<script>
export default {
    name: 'IconAdd',
}
</script>
<template>
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 64 64"
        class="base-icon icon-add"
    >
        <g clip-path="url(#a)">
            <path 
                fill="currentColor" 
                fill-rule="evenodd" 
                d="M36.8 0v27.2H64v9.6H36.8V64h-9.6V36.8H0v-9.6h27.2V0h9.6Z" 
            />
        </g>
        <defs>
            <clipPath id="a">
                <path fill="#fff" d="M0 0h64v64H0z"/>
            </clipPath>
        </defs>
    </svg>
</template>
